import { environment } from '../../../../shared/utils/fetchEnv/env'
import { getBlaize } from '../../../../shared/utils/getBlaize'

type CaseNotSupported = {
  isSupported: false
}

type MemberNotEntitled = {
  isSupported: true
  isEntitled: false
  category: 'legal' | 'tech' | 'money'
}

type MemberEntitled = {
  isSupported: true
  isEntitled: true
  anyExpertAppointmentUrl: string
  sameExpertAppointmentUrl: string
}
export type FollowUpAppointmentResponse = MemberNotEntitled | MemberEntitled | CaseNotSupported

export const getIFrameData = async (
  appointmentId: string
): Promise<FollowUpAppointmentResponse> => {
  const blaize = getBlaize()
  if (!appointmentId || !blaize) {
    throw new Error('Incorrect appointment id passed in')
  }

  const response = await fetch(
    `https://${environment()}-appointment-booking-rebooking-service.api.product.which.co.uk/rebooking-service/follow-up-appointment?appointmentId=${appointmentId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: blaize,
        'User-Agent': window.navigator.userAgent,
        'X-Forwarded-Application': `which-tool-framework/${environment()}`,
      },
    }
  )

  if (!response.ok) {
    throw new Error('unexpected error')
  }

  return response.json()
}
